import {
    AfterContentChecked,
    AfterContentInit,
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    QueryList,
    ViewChild,
} from '@angular/core';

import { FeatureDetectionService } from '../utils/helpers/feature-detection.service';
import { TabComponent } from './tab.component';

@Component({
    selector: 'app-tab-group',
    template: `
        <div class="tab-group">
            <div class="tab-group__tabs" #tabsWrapper>
                <h6 class="tab-group__tabs--item {{ 'tab-id-' + i }}"
                    role="tab"
                    *ngFor="let tab of tabs; let i = index"
                    [class.is-active]="i === activeTab"
                    [attr.tabIndex]="_getTabIndex(i)"
                    [attr.aria-posinset]="i + 1"
                    [attr.aria-setsize]="_tabs.length"
                    [attr.aria-selected]="activeTab === i"
                    (click)="setActive(i)">
                    {{ tab }}
                </h6>
            </div>

            <ng-content></ng-content>
        </div>
    `,
})
export class TabGroupComponent implements AfterContentChecked, AfterContentInit {
    @ContentChildren(TabComponent) _tabs: QueryList<TabComponent>;

    @ViewChild('tabsWrapper') _navElement: ElementRef<HTMLDivElement>;
    @Input() initialActiveIndex = 0;
    @Output() handleClick = new EventEmitter();

    tabs?: string[];
    activeTab: number;

    constructor(private featureDetectionService: FeatureDetectionService) {}

    ngAfterContentChecked() {
        if (this._tabs && this._tabs.length) {
            this.tabs = this._tabs.map((x) => x.label || '');

            // Check if there is only one tab
            if (this._tabs.length === 1) {
                this.setActive(0); // Set the first tab as active
            } else if (this.activeTab === undefined) {
                this.setActive(this.initialActiveIndex); // Set the initial active tab
            }
        }
    }

    ngAfterContentInit() {
        this.setActive(this.initialActiveIndex);       
    }

    setActive(index: number): void {
        this.activeTab = index;
        this._tabs?.forEach((x) => x.setActive(false));

        const activeTab = this._tabs?.toArray()[this.activeTab];
        if (activeTab) {
            activeTab.setActive(true);
        }

        this.handleClick.emit(index);

        if (this._navElement) {
            const navElementWidth = this._navElement.nativeElement.offsetWidth;
            const activeLink = this._navElement.nativeElement.querySelector<HTMLDivElement>('.tab-id-' + this.activeTab);

            if (activeLink) {
                const activeLinkLeft = activeLink.offsetLeft;
                const activeLinkWidth = activeLink.offsetWidth;

                let left = 0;
                if (this.activeTab !== 0) {
                    left = activeLinkLeft - navElementWidth / 2 + activeLinkWidth / 2;
                }

                if (this.featureDetectionService.isBrowser()) {
                    this._navElement.nativeElement.scroll({
                        left,
                        behavior: 'smooth',
                    });
                }
            }
        }
    }

    _getTabIndex(idx: number): number {
        return this.activeTab === idx ? 0 : -1;
    }
}
